// src/components/Pricing/Upgrade.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useUserContext } from '../../contexts/UserContext';
import './Pricing.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://http://https://southamerica-east1-drecenna.cloudfunctions.net/api';

const Upgrade = () => {
  const { user, subscription, subscriptionLoading, refreshSubscription } = useUserContext();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Atualizar os dados da assinatura ao carregar a página
    refreshSubscription();
  }, [refreshSubscription]);

  // Planos disponíveis
  const plans = [
    {
      id: 'personal',
      name: 'Pessoal',
      price: 'R$99',
      frequency: '/mês',
      features: [
        'Acesso às funcionalidades básicas',
        'Uso para 1 usuário',
        'Suporte por email'
      ],
      buttonText: 'Assinar Plano Pessoal',
      popular: false
    },
    {
      id: 'business',
      name: 'Empresarial',
      price: 'R$249',
      frequency: '/mês',
      features: [
        'Todas as funcionalidades do plano Pessoal',
        'Uso para até 5 usuários',
        'Suporte prioritário',
        'Relatórios avançados'
      ],
      buttonText: 'Assinar Plano Empresarial',
      popular: true
    },
    {
      id: 'business_pro',
      name: 'Empresarial Pro',
      price: 'R$349',
      frequency: '/mês',
      features: [
        'Todas as funcionalidades do plano Empresarial',
        'Uso para até 20 usuários',
        'Suporte 24/7',
        'API personalizada',
        'Consultoria dedicada'
      ],
      buttonText: 'Assinar Plano Empresarial Pro',
      popular: false
    }
  ];

  const handleUpgrade = async (planType) => {
    if (!user || !user.email) {
      setError('Você precisa estar logado para fazer upgrade.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API_URL}/create-checkout-session`, {
        planType,
        email: user.email
      });

      // Redirecionar para o checkout do Stripe
      window.location.href = response.data.url;
    } catch (error) {
      console.error('Erro ao iniciar checkout:', error);
      setError('Erro ao iniciar o checkout. Por favor, tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  // Identificar o plano atual do usuário
  const currentPlanId = subscription?.planType || null;

  return (
    <div className="pricing-container upgrade-container">
      <div className="pricing-header">
        <h1>Atualize seu Plano</h1>
        {currentPlanId && (
          <p className="current-plan">
            Seu plano atual: <strong>{plans.find(p => p.id === currentPlanId)?.name || 'Desconhecido'}</strong>
          </p>
        )}
        {subscription?.status === 'past_due' && (
          <div className="payment-warning">
            Há um problema com seu pagamento. Por favor, atualize suas informações de pagamento.
          </div>
        )}
      </div>

      {error && <div className="error-message">{error}</div>}

      <div className="pricing-plans">
        {plans.map((plan) => (
          <div 
            key={plan.id}
            className={`pricing-card ${plan.popular ? 'popular' : ''} ${plan.id === currentPlanId ? 'current-plan' : ''}`}
          >
            {plan.popular && <div className="popular-badge">Mais Popular</div>}
            {plan.id === currentPlanId && <div className="current-plan-badge">Plano Atual</div>}
            
            <h2>{plan.name}</h2>
            <div className="price">
              <span className="amount">{plan.price}</span>
              <span className="frequency">{plan.frequency}</span>
            </div>
            <ul className="features">
              {plan.features.map((feature, index) => (
                <li key={index}>✓ {feature}</li>
              ))}
            </ul>
            <button 
              className="subscribe-button"
              onClick={() => handleUpgrade(plan.id)}
              disabled={loading || plan.id === currentPlanId || subscriptionLoading}
            >
              {loading ? 'Processando...' : 
               plan.id === currentPlanId ? 'Plano Atual' : 
               `Upgrade para ${plan.name}`}
            </button>
          </div>
        ))}
      </div>
      
      <div className="pricing-footer">
        <p>Você será cobrado proporcionalmente ao tempo restante do seu plano atual.</p>
        <button 
          className="back-button"
          onClick={() => navigate('/dashboard')}
        >
          Voltar para o Dashboard
        </button>
      </div>
    </div>
  );
};

export default Upgrade;